import script from "./SubscribeNewsletterView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeNewsletterView.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeNewsletterView.vue?vue&type=style&index=0&id=3fa37ab6&lang=scss"

const __exports__ = script;

export default __exports__